import Header from '../components/Header'
import Footer from '../components/Footer'
import Head from '../components/Head'
import * as common from '../common/commonFunction'
import { useSpring, animated } from 'react-spring';
import { useState,useEffect } from 'react';
import $ from 'jquery';
import axios from "axios";

const FAQ = () => {

    const [state, toggle] = useState(true)
    const [page, setPage] = useState(0);
    const [faqList, setFaqList] = useState([])
    const { x } = useSpring({ from: { x: 0 }, x: state ? 1 : 0, config: { duration: 2000 } })

    useEffect(() => {
        getFaq();
    }, [])

    const clickEvent = (e) => {
        $(e.target).parent('.link').parent('li').find('.submenu').toggle('fast');

        if (!$(e.target).parent('.link').parent('li').hasClass('open')) {
            $(e.target).parent('.link').parent('li').addClass('open');
        } else {
            $(e.target).parent('.link').parent('li').removeClass('open');
        }
    }

    const getFaq = async () => {

        //get Faq list 
        const option = {
            url: "/announcement/faq/all?pageSize=20&currentPage="+page,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        }

        axios(option)
            .then(response => {
                if (response.data.code === 200) {
                    setFaqList(response.data.data);
                }
            });
    }


    return (
        <>
            <Head />
            <Header />
            <div className="container" style={{ width: "100%" }} onClick={() => common.focusOutMenu()}>
                <content>
                    <div className="input-form" style={{ textAlign: "center" }}>
                        <div className="animate__animated animate__rubberBand" style={{ margin: "5rem 0" }}>
                            <h4>General Questions</h4>
                        </div>
                        <ul id="accordion" className="accordion row" style={{ textAlign: "justify" }}>
                            {faqList && faqList.map((item,index) => {
                                return <li>
                                        <div className="link" style={{ margin: "2rem 0", fontSize: "2rem" }}>
                                           {item.question} <i className="fa fa-chevron-down" onClick={clickEvent}></i>
                                        </div>
                                        <ul className="submenu">
                                            <li>
                                                <div dangerouslySetInnerHTML={{__html: item.answer}}></div>
                                            </li>
                                        </ul>
                                    </li>
                            })}
                        </ul >
                    </div >
                </content >
            </div >
            <Footer />
        </>
    )
}
export default FAQ;